

export const DEFAULT_ZIPCODES_GET_ERROR = 'Failed to Pay';